import * as React from 'react';
import { Row, Col } from 'reactstrap';
import FieldBase from './FieldBase';
import { IFieldBaseProperties, IFieldValueProperties, IFieldEvent, IValidationProperties } from './interfaces';
import FieldTypes from './enums/FieldTypes';
import DateField, { DateFormat } from './DateField';
import { IFormValidationProperties } from '../../model/forms';

interface IDateField extends IValidationProperties {
  name: string;
  value?: string;
  placeholder?: string;
}

interface IDateRangeFieldProperties extends IFieldBaseProperties, IFieldValueProperties, IFormValidationProperties {
  from: IDateField;
  to: IDateField; 
  onChange?: (event: IFieldEvent) => void;
  format?: DateFormat;
}

export class DateRangeField extends React.PureComponent<IDateRangeFieldProperties> {
  constructor(props: IDateRangeFieldProperties) {
    super(props);

    this.onChange = this.onChange.bind(this);
  }

  onChange(event: React.FormEvent<HTMLInputElement>) {
    event.preventDefault();

    if (this.props.onChange !== undefined)
    {
      this.props.onChange({
        id: event.currentTarget.id,
        name: event.currentTarget.name,
        value: event.currentTarget.value
      });
    }
  }

  render() {
    return <React.Fragment>
      <FieldBase key={`${this.props.id}_date_range`} {...this.props} type={FieldTypes.TEXT}>
        <Row key={`${this.props.id}_field_group_row`}>
          <Col key={`${this.props.id}_field_group_row_from`} xs={12} sm={6} className="text-left">
            <DateField 
              key={`${this.props.id}_date_range_from`} 
              value={this.props.from.value || ''} 
              {...this.props} 
              id={this.props.from.name} 
              label={this.props.from.placeholder || 'From'} 
              valid={this.props.from.valid} 
              message={this.props.from.message}
              max={this.props.to.value}
              maxErrorMessage={`Cannot be after ${this.props.to.placeholder || 'To'}`} />
          </Col>
          <Col key={`${this.props.id}_field_group_row_to`} xs={12} sm={6} className="text-left">
            <DateField 
              key={`${this.props.id}_date_range_to`} 
              value={this.props.to.value || ''} 
              {...this.props} 
              id={this.props.to.name} 
              label={this.props.to.placeholder || 'To'} 
              valid={this.props.to.valid} 
              message={this.props.to.message} />
          </Col>
        </Row>
      </FieldBase>
    </React.Fragment>;
  }
}

export default DateRangeField;